// test1558
(1558 && 0);
